import {useEffect} from 'react';
import {useHref} from 'react-router';
import {Head} from 'zudoku/components';

export default function NotFoundRedirect(): React.ReactNode {
  const rootHref = useHref('/home');
  const homeHref = rootHref.replace(/\/+$/, '') || '/';

  useEffect(() => {
    window.location.replace(homeHref);
  }, [homeHref]);

  return (
    <Head>
      <meta http-equiv="refresh" content={`0;url=${homeHref}`} />
    </Head>
  );
}
